module.exports = __webpack_public_path__ + "media/application/images/svgs/slash-fecf183721a3747c4b1d0e155c8d42c3.svg";